import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { isProductionMode } from '@utils/get-environment/get-environment';

import { App } from './app';
import { i18nInitPromise } from './i18n';

import './index.css';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

const renderApp = () => {
  root.render(<App />);
};

i18nInitPromise.then(() => {
  if (isProductionMode) {
    renderApp();
  } else {
    import('@axe-core/react').then((axe) => {
      axe.default(React, ReactDOM, 1000);
      renderApp();
    });
  }
});
